<h2 rds-dialog-header>Session Expired</h2>
<div rds-dialog-content class="tos">
    Your session has expired. Please log in again.
</div>
<div rds-dialog-actions-container>
    <button rds-primary-button [rds-dialog-close]="true" size="s">
        Log in
    </button>
</div>
